"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _Cross = _interopRequireDefault(require("../../Icons/Cross"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: ", ";\n\ttop: ", ";\n\tcursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-family: 'galano-bold', 'galano', sans-serif;\n\tfont-weight: bold;\n\tpadding: ", " ", " ", " ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Content = _styledComponents.default.div(_templateObject(), _spacing.default.s2, _spacing.default.s5, _spacing.default.s2, _spacing.default.s2, _colors.default.primary, _colors.default.white);

Content.displayName = 'Content';
var Close = (0, _styledComponents.default)(_Cross.default)(_templateObject2(), _spacing.default.s2, _spacing.default.s2);
Close.displayName = 'Close';

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      close = _ref.close,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "close", "className"]);

  return _react.default.createElement(Content, _extends({
    className: className
  }, rest), children, _react.default.createElement(Close, {
    size: 20,
    onClick: close,
    "aria-label": "Close modal",
    role: "button",
    id: "close-modal"
  }));
};

ModalHeader.displayName = 'ModalHeader';
ModalHeader.propTypes = {
  children: _propTypes.node,
  close: _propTypes.func,
  className: _propTypes.string
};
ModalHeader.defaultProps = {
  children: '',
  close: function close() {},
  className: ''
};
var _default = ModalHeader;
exports.default = _default;